import * as React from 'react';
const CadutaDeiCapelliIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M94.95 67.95s-21.37 32.82-21.37 54.95c0 6.96 2.61 9.16 5.47 9.16 2.38 0 3.69-1.53 3.69-4.58 0-4.26-3.05-3.12-3.05-10.68 0-21.46 15.26-48.84 15.26-48.84"
      className="prefix__cls-2"
    />
    <path
      d="M139.21 116.79h-3.05c-7.63 0-10.77-1.53-13.74-1.53-.32 0-.67.11-1.04.26-1.44.63-2.2 2.18-1.82 3.68.15.56.35.87.61 1.25.84 1.25 2.24 3.33 2.24 7.02 0 7.39-4.91 10.68-9.8 10.68-1.92 0-11.57-.73-11.57-15.26 0-2.82.95-4.7-.01-6.12-.32-.46-.84-.87-1.68-1.25-.35-.15-.72-.26-1.04-.26-.36 0-.87.05-1.43.12-2.17.28-4.42.28-6.59-.01-.5-.07-.99-.11-1.46-.11-.32 0-.67.11-1.04.26-1.44.63-2.2 2.18-1.82 3.68.15.56.35.87.61 1.25.84 1.25 2.24 3.33 2.24 7.02 0 7.39-4.92 10.68-9.8 10.68-1.92 0-11.57-.73-11.57-15.26 0-3.75 1.66-5.85-1.69-7.37-.35-.15-.72-.26-1.04-.26-2.95 0-5.85 1.53-9.48 1.53"
      className="prefix__cls-2"
    />
    <path
      d="M140.74 61.84s-28.76 26.18-34.42 47.57c-1.78 6.73.15 9.53 2.88 10.27 2.28.62 3.91-.52 4.69-3.47 1.09-4.12-2.12-3.8-.18-11.12 5.49-20.74 27.04-43.25 27.04-43.25M130.05 86.26l9.16-1.52-3.05 9.15"
      className="prefix__cls-1"
    />
    <path
      d="M139.21 84.74c-7.81 4.48-12.94 12.4-13.74 21.37"
      className="prefix__cls-1"
    />
  </svg>
);
export default CadutaDeiCapelliIcon;
